import { isProductionEnv } from "../utils/generalUtils";

const PRODUCTION_URL = "";

const DEV_URL = "http://cb-ewa/dev/";
const DEV_IP_URL = "http://192.168.200.35/dev/";
const DEV_DAILY_URL = "http://cb-ewa/devDaily/";
const DEV_PUBLIC_URL = "https://flowio.popronsystems.cz/dev/";
const DEV_DAILY_PUBLIC_URL = "https://flowio.popronsystems.cz/devDaily/";
const DEV_DAILY_IP_URL = "http://192.168.200.35/devDaily/";
const TEST_URL = "http://cb-ewa/test/";
const TEST_URL_PUBLIC = "https://flowio.popronsystems.cz/test/";
const PRERELEASE_URL_PUBLIC = "https://flowio.popronsystems.cz/prerelease/";
const LOCAL_URL = "https://localhost:5001/";
const DOCKER_URL = "http://localhost:5000/";
const SAMEORIGIN_URL = "";
const MASTER_URL = "https://flowio.popronsystems.cz/master/";
const DEVELOPMENT_TEST_PUBLIC_URL =
  "https://flowio.popronsystems.cz/developmenttest";

const determineUrl = (): string => process.env.REACT_APP_BE_URL as string;

export default determineUrl();
